<ng-container *ngIf="false">
  <div class="col-12 sub-header d-flex justify-content-between">
    <div class="info-user d-flex justify-content-center">
      <p class="my-0">
        Olá, <strong>{{ headerPageSignalDataService.nameUser$() }}</strong
        >. {{ mensagemSaudacao }}
        <br />
        Seu último acesso foi em
        <strong>{{ headerPageSignalDataService.lastAccess$() }}</strong
        >.
      </p>
    </div>
    <div class="col d-flex align-items-center justify-content-center">
      <button
        nz-button
        type="button"
        nzType="default"
        [nzSize]="size"
        routerLink="/formulario"
        *ngIf="isUser()"
        class="d-flex justify-align-center align-items-center rounded-2 bg-transparent border-0 shadow-none mx-3"
      >
      <i class="fi fi-rr-document fs-5 pe-3 mr-1"></i>
            Formulários
      </button>
      <button
        nz-button
        type="button"
        nzType="default"
        [nzSize]="size"
        routerLink="/configuracao"
        *ngIf="isAdministrator()"
        class="d-flex justify-align-center align-items-center rounded-2 bg-transparent border-0 shadow-none mx-3"
      >
        <i class="fi fi-rs-settings fs-5 pe-3 mr-1"></i>
        Parametrização
      </button>

      <button
        nz-button
        type="button"
        nzType="default"
        [nzSize]="size"
        routerLink="/contato"
        *ngIf="isUser()"
        class="d-flex justify-align-center align-items-center rounded-2 bg-transparent border-0 shadow-none mx-3"
      >
      <i class="fi fi-rr-envelope fs-5 pe-3 mr-1"></i>
        Contato
      </button>
    </div>
  </div>
</ng-container>

